<template>
  <label class="ui-switch-wrapper">
    <div
      class="ui-switch"
      :class="{
        [`ui-switch_${type}`]: type,
        [`ui-switch_${size}`]: size,
        'ui-switch_disabled': disabled,
      }"
    >
      <input
        :value="value"
        :checked="value"
        :disabled="disabled"
        type="checkbox"
        @input="$emit('input', !value)"
      />
      <div class="ui-switch__slider round" />
    </div>

    <div
      v-if="label"
      class="ui-switch__label"
    >
      {{ label }}
    </div>

    <el-tooltip
      v-if="labelInfo"
      placement="top"
    >
      <div slot="content">
        <div v-html="labelInfo" />
      </div>

      <i class="nc-icon nc-alert-circle-i ui-switch-wrapper__label-info"></i>
    </el-tooltip>
  </label>
</template>

<script>
import { Tooltip } from 'element-ui';

export default {
  name: 'Switcher',

  components: {
    [Tooltip.name]: Tooltip,
  },

  props: {
    value: {
      type: Boolean,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    labelInfo: {
      type: String,
      default: '',
    },
    type: String,
    size: String,
    disabled: Boolean,
  },
};
</script>
